export default "__VITE_ASSET__CRo34rga__"